// extracted by mini-css-extract-plugin
module.exports = {"container":"SetupLink_container__mnMut","description":"SetupLink_description__3MJ-b","body":"SetupLink_body__3olQK"};